import React from 'react';
import PropTypes from 'prop-types';
import { scrollToElement } from '../../utils/scroll-to';

import styles from './index.module.scss';

const TableOfContents = ({ tableOfContents }) => (
  <ul className={styles['table-of-contents']}>
    {tableOfContents.map((item) => (
      <li key={item.id}>
        <a
          href={`#${item.id}`}
          onClick={(e) => {
            // Disable default link behaviour.
            e.preventDefault();
            // Scroll to the ref using helper method which takes the sticky header
            // in considereation.
            scrollToElement({ elementId: item.id, offset: 120 });
            // Update URL for those who want to share the link.
            window.history.pushState(null, null, `#${item.id}`);
          }}
        >
          {item.label}
        </a>
      </li>
    ))}
  </ul>
);

TableOfContents.propTypes = {
  tableOfContents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
    }).isRequired,
  ).isRequired,
};

export default TableOfContents;
